import { render, staticRenderFns } from "./px-bottom-bar.vue?vue&type=template&id=7fc915b2&scoped=true&"
import script from "./px-bottom-bar.vue?vue&type=script&lang=ts&"
export * from "./px-bottom-bar.vue?vue&type=script&lang=ts&"
import style0 from "./px-bottom-bar.vue?vue&type=style&index=0&id=7fc915b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc915b2",
  null
  
)

export default component.exports